module.exports = __webpack_public_path__ + "static/img/study_report.8fc9f6aa.png";